import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { starEmptyIcon, starFillIcon } from '@/assets/icons';
import { colorAccent400 } from '@/styleUtils';
import { getIconSpriteUrl } from '@/utils';

import { Content, RatingValue, Star, Wrapper } from './StarsList.styles';

function StarsList({
  value = 0,
  size = 16,
  length = 5,
  padding = 1,
  color = colorAccent400,
  isSimpleStyle = false,
  textValue = false,
  text = '',
}) {
  const { formatNumber } = useIntl();
  const width = (count) =>
    !isSimpleStyle ? (size + 2 * padding) * count : size + 2 * padding;
  const height = 2 * padding + size;

  return (
    <Wrapper>
      <Content $width={width(length)} $height={height}>
        <Star
          $type="empty"
          $color={color}
          $background={getIconSpriteUrl(starEmptyIcon.id)}
          $size={size}
          $width={width(length)}
          $height={height}
        />
        {Number(value) ? (
          <Star
            $type="filled"
            $position="relative"
            $background={getIconSpriteUrl(starFillIcon.id)}
            $size={size}
            $width={width(value)}
            $color={color}
            $height={height}
          />
        ) : null}
      </Content>
      {textValue && (
        <RatingValue>
          {formatNumber(value)}
          &nbsp;
          {text}
        </RatingValue>
      )}
    </Wrapper>
  );
}

StarsList.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  length: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  isSimpleStyle: PropTypes.bool,
  textValue: PropTypes.bool,
  text: PropTypes.string,
};

export default memo(StarsList);
